import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { supabase } from '../../../lib/supabase';

const TestimonialSection = () => {
  const [conteudo, setConteudo] = useState<any>(null);
  const [testemunhosAprovados, setTestemunhosAprovados] = useState<any[]>([]);

  useEffect(() => {
    carregarConteudo();
    carregarTestemunhos();
  }, []);

  const carregarConteudo = async () => {
    const { data } = await supabase
      .from('conteudo_inicio')
      .select('*')
      .eq('secao', 'testimonials')
      .maybeSingle();

    if (data) {
      setConteudo(data);
    }
  };

  const carregarTestemunhos = async () => {
    const { data } = await supabase
      .from('testemunhos')
      .select('*')
      .eq('status', 'aprovado')
      .order('criado_em', { ascending: false });

    if (data && data.length > 0) {
      setTestemunhosAprovados(data);
    }
  };

  const titulo = conteudo?.titulo || 'O Que Dizem os Nossos Alunos';
  const subtitulo = conteudo?.subtitulo || 'Histórias de Sucesso Reais';
  
  const testimonials = testemunhosAprovados;

  if (testimonials.length === 0) return null;

  return (
    <section className="py-20 px-4 bg-black">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {titulo}
          </h2>
          <p className="text-xl text-gray-400">{subtitulo}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial: any, index: number) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-8 hover:border-yellow-400/50 transition-all"
            >
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
                  <img
                    src={testimonial.avatar || 'https://public.readdy.ai/ai/img_res/07237bd3241cecd80a694964b47f9ae9.jpg'}
                    alt={testimonial.nome}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="text-white font-bold">{testimonial.nome}</h4>
                  <p className="text-gray-400 text-sm">{testimonial.cargo}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>

              <p className="text-gray-300 leading-relaxed">
                "{testimonial.texto}"
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;